import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { FooterTrustSealProps } from '../types/interfaces'
// assets
import { TRUST_SEALS } from '../images'
import type { FooterSealImage } from '../images'

interface FooterTrustSealHookOptions {
  props: FooterTrustSealProps
}

interface FooterTrustSealHookReturn {
  refImage: ComputedRef<FooterSealImage>
}

export const useFooterTrustSeal = ({ props }: FooterTrustSealHookOptions): FooterTrustSealHookReturn => {
  const refImage = computed<FooterSealImage>(() => TRUST_SEALS[props.seal])

  return {
    refImage,
  }
}
